module.exports = __webpack_public_path__ + "static/img/title.b28a5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/servitor/circus/title.png
// module id = uujs
// module chunks = 7